import Link   from '../components/link';
import Navbar from '../components/navbar';
import React  from 'react';



export default function DashboardPage() {
  return (
    <React.Fragment>
      <Navbar title="Dashboard"/>

      <div className="page-content">
        <div className="block">
          <p><b>The Broadly Dashboard is designed for you to:</b></p>

          <ul>
            <li><b>Address</b> customer feedback</li>
            <li><b>Reply</b> to online reviews</li>
            <li><b>Review</b> your online reputation</li>
            <li><b>Track</b> your team’s performance</li>
            <li><b>Compare</b> performance of multiple locations</li>
          </ul>

          <p>You will be able to access the dashboard with your Broadly credentials.</p>

          <div className="block">
            <p className="buttons-row">
              <Link href="https://dashboard.broadly.com" external className="button button-fill">
                Open Dashboard
              </Link>
            </p>
          </div>

          <p>We recommend exploring the dashboard on your desktop for a better viewing experience.</p>
        </div>
      </div>
    </React.Fragment>
  );
}
